let connectName = "dda-financial-cc-prod01";
  let loginUrl = "https://myapps.microsoft.com/signin/305a5bd4-03a7-4c7c-96bd-ac4290ca44bd?tenantId=11d0e217-264e-400a-8ba0-57dcc127d72d&RelayState=https%3a%2f%2fus-west-2.console.aws.amazon.com/connect/federate/53c2873a-2d93-4166-a243-3294d046b72b?destination=%2Fconnect%2Fccp-v2";
  let apiGatewayID = "573mbtcqmj";
  let apiGatewayStageName = "prod"
  let region = "us-west-2";

  // set default values
  export const CONNECT_NAME = connectName.includes("<") ? "company-name-connect-dev" : connectName;
  export const CONNECT_URL = "https://" +CONNECT_NAME + ".my.connect.aws/connect/";
  export const CCP_URL = "https://" + CONNECT_NAME + ".my.connect.aws/connect/ccp-v2";
  export const LOGIN_URL = loginUrl.includes("<") ? "NA" : loginUrl;
  export const REGION = region.includes("<") ? "NA" : region;
  export const API_GATEWAY_STAGE_NAME = apiGatewayStageName.includes("<") ? "NA" : apiGatewayStageName;
  export const API_GATEWAY_ID = apiGatewayID.includes("<") ? "<<API_GATEWAY_ID>>" : apiGatewayID;
  export const API_HOST = "https://" + API_GATEWAY_ID + ".execute-api." + REGION + ".amazonaws.com/" + API_GATEWAY_STAGE_NAME + "/getqueuemetrics";